import Vue from "vue";
import SvgIcon from "@/components/MRC_ESS_SvgIcon";

// 注册到全局
Vue.component("svg-icon", SvgIcon);
const requireAll = (requireContext) =>
  requireContext.keys().map(requireContext);
const req = require.context("./svg", true, /\.svg$/);
requireAll(req);
